import { createSelector } from 'reselect';
import { reorderPageSectionPdpSelector } from 'selectors/testTarget/offers/reorderPageSectionPdp/reorderPageSectionPdpSelector';

const experienceSelector = createSelector(reorderPageSectionPdpSelector, reorderPageSectionPdp => reorderPageSectionPdp.experience);

export { experienceSelector };
